import React, { useEffect, useState } from "react";
import { Box, Button, Flex, Spinner, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getTimeLevelDetailsById } from "../services/attendanceSettingServices";
import TimeLeveldetailsTable from "../components/TimeLeveldetailsTable";
import NoDataFound from "components/ui/noDataFound/NoDataFound";
import AddNewShift from "../components/modal/AddNewShift";

export default function TimeShiftDetails() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const data = useSelector((state) => state.attendanceSetting);
  // console.log(data);
  const [showNewShiftModal, setShowNewShiftModal] = useState(false);

  useEffect(() => {
    dispatch(getTimeLevelDetailsById(id));
  }, [dispatch, id]);

  //--------------------------------- Compponents Return ----------------------------------------//
  if (data?.isLoading) {
    return (
      <Flex
        bg="light"
        p={4}
        gap={2}
        justifyContent="center"
        flexDir={"column"}
        alignItems={"center"}
      >
        <Spinner />
        <Text fontWeight={"bold"}> Loading </Text>
      </Flex>
    );
  }

  return (
    <>
      <Box>
        <Box
          bg="light"
          marginInline={-6}
          marginTop={-6}
          padding={6}
          borderTop="1px solid"
          borderColor="border"
          marginBottom={6}
        >
          <Flex alignItems="center" justifyContent="space-between" gap={4}>
            <Text fontSize="1.2rem" color="dark" textTransform="capitalize">
              {t("pages.hr.attendance.time_shift_details")}
            </Text>

            <Button
              type="button"
              bg="primary"
              color="light"
              textTransform="capitalize"
              fontSize="1rem"
              onClick={() => setShowNewShiftModal(true)}
            >
              {t("pages.hr.attendance.add_new_shift")}
            </Button>
          </Flex>
        </Box>

        <Box>
          {data?.TimeLeavelDetails?.length > 0 ? (
            <TimeLeveldetailsTable />
          ) : (
            <NoDataFound />
          )}
        </Box>
      </Box>
      {showNewShiftModal && (
        <AddNewShift onClose={() => setShowNewShiftModal(false)} id={id} />
      )}
    </>
  );
}
